import {Navigate, Outlet, useLocation} from 'react-router-dom'
import {useStore} from 'rest/stores'
import {observer} from 'mobx-react'

type Props = {
  /* Redirection path when it's authenticated */
  to: string
}

export const AuthRoute = observer(({to}: Props) => {
  let {AuthStore} = useStore()
  let location = useLocation()
  return AuthStore.authenticated ? (
    <Navigate to={to} state={{from: location}} replace />
  ) : (
    <Outlet />
  )
})
